module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Stocks with a business card":"Lager mit Visitenkarte","Pick at least one stock to add a business card.":"Wähle mindestens ein Lager, um eine Visitenkarte hinzuzufügen.","Stock address":"Lageradresse","Stock has no address":"Lager hat keine Adresse"}}')
  delete Component.options._Ctor
}
